// extracted by mini-css-extract-plugin
export default {"Page":"Page_Page__Jcnwd","block":"Page_block__WPR1+","autohide":"Page_autohide__bAbob"};